import { RESOLUTIONS } from "./chart-helpers"
import { User } from "./models"

export const Breakpoints = {
  XS: 540,
  SM: 740,
  MD: 960,
  LG: 1340,
  XL: 1400,
  XXL: 1400,
} as const

export enum MediaQuery {
  XS = `@media (max-width: 540px)`,
  SM = `@media (max-width: 740px)`,
  MD = `@media (max-width: 960px)`,
  LG = `@media (max-width: 1340px)`,
  XL = `@media (min-width: 1400px)`,
  XXL = `@media (min-width: 1400px)`,
}

export const radioButtonBarItems = [
  { id: RESOLUTIONS.year, title: "Year" },
  { id: RESOLUTIONS.month, title: "Month" },
  { id: RESOLUTIONS.day, title: "Day" },
]

export const contactInformation = {
  email: { value: "info@satcube.com", title: "info@satcube.com" },
  phone: { value: "00460317010500", title: "+46 (0) 31 701 05 00" },
}

export const PAGINATION_VALUE = 10
export const PAGINATION_VALUE_PRESETS = [10, 25, 50, 75, 100]

export const TERMINAL_MAX_WARNING = 90

export enum NOTIFICATION_TYPES {
  CREATE_ORG = "CREATE_ORG",
  DELETE_ORG = "DELETE_ORG",
  CHANGE_ORG = "CHANGE_ORG",
  CREATE_OG = "CREATE_OG",
  DELETE_OG = "DELETE_OG",
  CREATE_OT = "CREATE_OT",
  CHANGE_OT = "CHANGE_OT",
  DELETE_OT = "DELETE_OT",
  CREATE_ORG_REQUEST = "CREATE_ORG_REQUEST",
  DELETE_ORG_REQUEST = "DELETE_ORG_REQUEST",
  UPDATE_ORG_REQUEST = "UPDATE_ORG_REQUEST",
  ACCEPT_ORG_REQUEST = "ACCEPT_ORG_REQUEST",
  KICKED_USER_FROM_ORG = "KICKED_USER_FROM_ORG",
  LOG_IN = "LOG_IN",
  LOG_OUT = "LOG_OUT",
  ERROR = "error type",
  CREATE_GROUP = "CREATE_GROUP",
  USER_ADDED = "USER_ADDED",
  USER_DELETED = "USER_DELETED",
  GROUP_CHANGED = "GROUP_CHANGED",
  TERMINAL_ADDED = "TERMINAL_ADDED",
  TERMINAL_DELETED = "TERMINAL_DELETED",
}

export const getActivityMessage = (
  type: NOTIFICATION_TYPES,
  user?: User,
  toUser?: User,
  group?: any,
  toTerminalSn?: string,
  toGroupName?: string,
  toOrganizationName?: string,
  toUserEmail?: string,
) => {
  switch (type) {
    case NOTIFICATION_TYPES.CREATE_ORG:
      return `${user?.firstName} ${user?.lastName} created organization ${toOrganizationName ? toOrganizationName : ""}`
    case NOTIFICATION_TYPES.DELETE_ORG:
      return `${user?.firstName} ${user?.lastName} deleted organization ${toOrganizationName ? toOrganizationName : ""}`
    case NOTIFICATION_TYPES.CHANGE_ORG:
      return `${user?.firstName} ${user?.lastName} changed organization billing details on ${
        toOrganizationName ? toOrganizationName : ""
      }`
    case NOTIFICATION_TYPES.CREATE_OG:
      return `${user?.firstName} ${user?.lastName} created group ${toGroupName ? toGroupName : ""}`
    case NOTIFICATION_TYPES.DELETE_OG:
      return `${user?.firstName} ${user?.lastName} deleted group ${toGroupName ? toGroupName : ""}`
    case NOTIFICATION_TYPES.CREATE_OT:
      return `${user?.firstName} ${user?.lastName} created terminal ownership` // curently not used
    case NOTIFICATION_TYPES.CHANGE_OT:
      return `${user?.firstName} ${user?.lastName} changed terminal ownership` // curently not used
    case NOTIFICATION_TYPES.DELETE_OT:
      return `${user?.firstName} ${user?.lastName} deleted terminal ownership` // curently not used
    case NOTIFICATION_TYPES.CREATE_ORG_REQUEST:
      return `${user?.firstName} ${user?.lastName} invited ${toUserEmail ? toUserEmail : "N/A"} to organization ${
        toOrganizationName ? toOrganizationName : ""
      }`
    case NOTIFICATION_TYPES.DELETE_ORG_REQUEST:
      return `${user?.firstName} ${user?.lastName} deleted invite to the organization ${
        toOrganizationName ? toOrganizationName : ""
      } for ${toUserEmail ? toUserEmail : "N/A"}`
    case NOTIFICATION_TYPES.UPDATE_ORG_REQUEST:
      return `${user?.firstName} ${user?.lastName} updated invite to the organization ${
        toOrganizationName ? toOrganizationName : ""
      } for ${toUserEmail ? toUserEmail : "N/A"}`
    case NOTIFICATION_TYPES.ACCEPT_ORG_REQUEST:
      return `${user?.firstName} ${user?.lastName} accepted invite the organization ${
        toOrganizationName ? toOrganizationName : ""
      } `
    case NOTIFICATION_TYPES.KICKED_USER_FROM_ORG:
      return `${user?.firstName} ${user?.lastName} kicked ${toUser ? toUser.firstName : "N/A"} ${
        toUser ? toUser.lastName : "N/A"
      } from organization ${toOrganizationName ? toOrganizationName : ""}`
    case NOTIFICATION_TYPES.CREATE_GROUP:
      return `${user?.firstName} ${user?.lastName} created group ${group?.name}` // curently not used
    case NOTIFICATION_TYPES.USER_ADDED:
      return `${toUser?.firstName} ${toUser?.lastName} was added to group ${group?.organizationGroup?.name}`
    case NOTIFICATION_TYPES.USER_DELETED:
      return `${toUser?.firstName} ${toUser?.lastName} was removed from group ${group?.organizationGroup?.name}`
    case NOTIFICATION_TYPES.GROUP_CHANGED:
      return `Group ${group?.name} permissions changed` // curently not used
    case NOTIFICATION_TYPES.TERMINAL_ADDED:
      return `${user?.firstName} ${user?.lastName} added terminal ${toTerminalSn} to group ${group?.organizationGroup?.name}`
    case NOTIFICATION_TYPES.TERMINAL_DELETED:
      return `${user?.firstName} ${user?.lastName} removed terminal ${toTerminalSn} from group ${group?.organizationGroup?.name}`
    default:
      return "N/A"
  }
}

export const activityLogFilterAlternatives: Array<{
  id: string
  title: string
}> = [
  {
    id: NOTIFICATION_TYPES.ACCEPT_ORG_REQUEST,
    title: "Accepted organization request",
  },
  { id: NOTIFICATION_TYPES.CHANGE_ORG, title: "Changed organization" },
  { id: NOTIFICATION_TYPES.CHANGE_OT, title: "Changed organization title" },
  { id: NOTIFICATION_TYPES.CREATE_GROUP, title: "Created group" },
  { id: NOTIFICATION_TYPES.CREATE_OG, title: "Created organization" },
  {
    id: NOTIFICATION_TYPES.CREATE_ORG_REQUEST,
    title: "Created organization request",
  },
  { id: NOTIFICATION_TYPES.CREATE_OT, title: "Created organization title" },
  { id: NOTIFICATION_TYPES.DELETE_OG, title: "Deleted group" },
  { id: NOTIFICATION_TYPES.DELETE_ORG, title: "Deleted organization" },
  {
    id: NOTIFICATION_TYPES.DELETE_ORG_REQUEST,
    title: "Deleted organization request",
  },
  { id: NOTIFICATION_TYPES.DELETE_OT, title: "Deleted organization title" },
  { id: NOTIFICATION_TYPES.GROUP_CHANGED, title: "Group changed" },
  {
    id: NOTIFICATION_TYPES.KICKED_USER_FROM_ORG,
    title: "Kicked user from group",
  },
  { id: NOTIFICATION_TYPES.LOG_IN, title: "Logged in" },
  { id: NOTIFICATION_TYPES.LOG_OUT, title: "Logged out" },
  {
    id: NOTIFICATION_TYPES.UPDATE_ORG_REQUEST,
    title: "Updated organization request",
  },
  { id: NOTIFICATION_TYPES.USER_ADDED, title: "User added" },
  { id: NOTIFICATION_TYPES.USER_DELETED, title: "User deleted" },
  { id: NOTIFICATION_TYPES.ERROR, title: "Other" },
  { id: NOTIFICATION_TYPES.TERMINAL_ADDED, title: "Terminal added to group" },
  {
    id: NOTIFICATION_TYPES.TERMINAL_DELETED,
    title: "Terminal deleted from group",
  },
]

export const allNotificationTypes = [
  NOTIFICATION_TYPES.ACCEPT_ORG_REQUEST,
  NOTIFICATION_TYPES.CHANGE_ORG,
  NOTIFICATION_TYPES.CHANGE_OT,
  NOTIFICATION_TYPES.CREATE_GROUP,
  NOTIFICATION_TYPES.CREATE_OG,
  NOTIFICATION_TYPES.CREATE_OT,
  NOTIFICATION_TYPES.CREATE_ORG_REQUEST,
  NOTIFICATION_TYPES.DELETE_OG,
  NOTIFICATION_TYPES.DELETE_ORG,
  NOTIFICATION_TYPES.DELETE_ORG_REQUEST,
  NOTIFICATION_TYPES.DELETE_OT,
  NOTIFICATION_TYPES.ERROR,
  NOTIFICATION_TYPES.GROUP_CHANGED,
  NOTIFICATION_TYPES.KICKED_USER_FROM_ORG,
  NOTIFICATION_TYPES.LOG_IN,
  NOTIFICATION_TYPES.LOG_OUT,
  NOTIFICATION_TYPES.UPDATE_ORG_REQUEST,
  NOTIFICATION_TYPES.USER_ADDED,
  NOTIFICATION_TYPES.USER_DELETED,
  NOTIFICATION_TYPES.TERMINAL_ADDED,
  NOTIFICATION_TYPES.TERMINAL_DELETED,
]

export const FALLBACK_PICTURE =
  "https://images.ctfassets.net/kzqg847wz5jr/5BuLlCZNeT1yQDzdcuHAHC/af17c5015281424ffc4c549fc6226782/Ska__rmavbild_2022-10-24_kl._15.08.26.png"

export const getTerminalGroupsText = (terminalGroups: Array<{ id: any; name: string }>) => {
  if (terminalGroups.length < 1) {
    return ""
  } else if (terminalGroups.length === 1) {
    return terminalGroups[0].name
  } else {
    return `${terminalGroups.length} groups`
  }
}
